import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popup, Checkbox, Switch, DropdownList } from 'next-common-lib';
import { useFormik } from 'formik';
import i18n from 'i18n';
import TextFieldFormik from 'components/Common/InputBox';
import TblList from 'components/Common/Template/TblList';
import PopConfirmButton from 'components/Common/Buttons/PopConfirmButton';
import TblCell from 'components/Common/Template/TblCell';
import * as boardActions from 'redux/ducks/Board/BoardDucks';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import BoardSchema from './BoardSchema';

export const PopupBoard = () => {
  const dispatch = useDispatch();
  const [vldTermDfltDdNum, setVldTermDfltDdNum] = useState(1);
  const [expArtiKeepMmNum, setExpArtiKeepMmNum] = useState(1);
  const isPopup = useSelector(state => state.wizard.isPopup);
  const board = useSelector(state => state.board);
  const adminVo = useSelector(state => state.adminInfo.adminVo);

  const formik = useFormik({
    initialValues: {
      brdNm: '',
      enBrdNm: '',
      brdMngOrgCd: adminVo.compCd,
      vldTermDfltDdNum: 0,
      expArtiKeepMmNum: 0,
      rcmdUseYn: 'N', // 추천사용
      cmntUseYn: 'N', // 댓글사용
      rplUseYn: 'N',
      bdBrdTypeCd: 'B', // 게시판유형코드
      anmsBrdYn: 'Y', // 작성자 익명처리
      brdVldYn: 'Y', // 게시판 사용여부
      fevtBrdYn: 'N', // 경조사게시판여부
      rplSecuGrdCd: 5, // 답변보안등급코드
      viewSecuGrdCd: 5,
      thUseYn: 'N', // 말머리 사용여부
      vldTermUseYn: 'N', // 유효기간 사용여부
      uprBrdNo: board.topMenuInfo?.topMenuNo, // 상위게시판
      portlet: 'N',
      useTrgtTypeCd: 'A',
      brdvTypeCd: 'A',
      regnInfYn: 'N',
      apInfUseYn: 'N',
      regSecuGrdCd: 5,
    },
    validationSchema: BoardSchema,
    onSubmit: values => {
      dispatch(boardActions.createBoard(values));
    },
  });

  const handleOnClosePopup = () => {
    formik.resetForm();
    setExpArtiKeepMmNum(1);
    setVldTermDfltDdNum(1);
    dispatch(wizardActions.closePopup());
  };

  const onSelectedChanged = named => {
    if (named === 'vldTermUseYn') {
      if (formik.getFieldProps(named).value === 'N') {
        formik.setFieldValue('expArtiKeepMmNum', expArtiKeepMmNum);
        formik.setFieldValue('vldTermDfltDdNum', vldTermDfltDdNum);
      } else {
        formik.setFieldValue('expArtiKeepMmNum', 0);
        formik.setFieldValue('vldTermDfltDdNum', 0);
      }
    }
    formik.setFieldValue(named, formik.getFieldProps(named).value === 'Y' ? 'N' : 'Y');
  };

  const handleOnDropdownItem = e => {
    formik.setFieldValue('vldTermDfltDdNum', e.value);
    setVldTermDfltDdNum(e.value);
  };

  useEffect(() => {
    if (board.isSuccess && formik.getFieldProps('portlet').value === 'Y') {
      formik.setFieldValue('portlet', 'N');
      const portletValues = {
        data: {
          titleKo: formik.getFieldProps('brdNm').value,
          titleEn: formik.getFieldProps('enBrdNm').value,
          url: '/boardapp/portlet01',
          urlType: 'I', // 내부 url
          activeYn: 'Y',
          urlParameter: `brdNo=${board.boardResult.brdNo}`, // brdno
          categoryTitle: adminVo.compNm,
        },
        categoryId: board.categoryId, // temp
      };
      dispatch(boardActions.createPortlet(portletValues));
    } else if (board.isSuccess) {
      handleOnClosePopup();
    }
  }, [board.isSuccess]);

  // 홈화면에 배치
  useEffect(() => {
    if (board.isSuccess) {
      let param = '';
      board.portletList.map((value, idx) => {
        param += `_${value},`;
      });

      dispatch(boardActions.arrangePortlet({ compCd: adminVo.compCd, data: `data=${param}##` }));
    }
  }, [board.portletList]);

  // 카테고리가 존재해야 포틀릿 등록이 가능
  useEffect(() => {
    if (!board.categoryId) {
      const category = {
        categoryLabel: '0',
        categoryType: 'PORTLET',
        titleKo: adminVo.compNm,
        titleEn: adminVo.enCompNm,
        activeYn: 'Y',
        deletedYn: 'N',
      };
      dispatch(boardActions.createCategory(category));
    }
  }, []);

  return (
    <>
      {isPopup && (
        <Popup
          id="boardPopup"
          isShow={isPopup}
          isDimed={isPopup}
          dimedClassName="transparent"
          isDimedOverlap
          zIndex={2000}
          size="sm w-popup"
          useScroll={false}
          componentType="normalPopup"
          closeFunction={() => {
            handleOnClosePopup();
          }}
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t('BTY_W_T_ADD_BORD')}
            </h1>,
          ]}
          contentsComponent={[
            <div className="article-body">
              <TblList>
                <TblCell isHeader isRequired>
                  {i18n.t('BTY_W_T_TITLE_KO_BOARD')}
                </TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="brdNm"
                    formik={formik}
                    placeholderLabel={i18n.t('BTY_W_T_TITLE_KO_INFO_BOARD')}
                    maxLength={30}
                    useExpLabel={formik.errors.brdNm !== undefined}
                    autoFocus
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader isRequired>
                  {i18n.t('BTY_W_T_TITLE_EN_BOARD')}
                </TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="enBrdNm"
                    formik={formik}
                    placeholderLabel={i18n.t('BTY_W_T_TITLE_EN_INFO_BOARD')}
                    maxLength={30}
                    useExpLabel={formik.errors.enBrdNm !== undefined}
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader>{i18n.t('PT_COMMON_SEASONSET')}</TblCell>
                <div className="cell">
                  <div className="inner-row">
                    <Switch
                      componentType="labelSwitch"
                      isLeftPosition
                      label={
                        formik.getFieldProps('vldTermUseYn').value === 'Y'
                          ? i18n.t('BTY_W_T_USE')
                          : i18n.t('BTY_W_T_NO_USE')
                      }
                      checked={formik.getFieldProps('vldTermUseYn').value === 'Y'}
                      onClick={() => {
                        onSelectedChanged('vldTermUseYn');
                      }}
                    />
                  </div>
                  {formik.getFieldProps('vldTermUseYn').value === 'Y' && (
                    <>
                      <div className="data-row">
                        <label htmlFor="checkbox">
                          <i className="check" />
                          <span className="sub-main-text">{i18n.t('BTY_W_T_EFFECT_PERIOD')}</span>
                        </label>
                        <span className="space" />
                        <DropdownList
                          componentType="border"
                          id="vldTermDfltDdNum"
                          label={vldTermDfltDdNum}
                          value={vldTermDfltDdNum}
                          breakNum={5}
                        >
                          <dropdownItem
                            key="1"
                            name="1"
                            value="1"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="2"
                            name="2"
                            value="2"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="3"
                            name="3"
                            value="3"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="4"
                            name="4"
                            value="4"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="5"
                            name="5"
                            value="5"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="6"
                            name="6"
                            value="6"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="7"
                            name="7"
                            value="7"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="8"
                            name="8"
                            value="8"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="9"
                            name="9"
                            value="9"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="10"
                            name="10"
                            value="10"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="20"
                            name="20"
                            value="20"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                          <dropdownItem
                            key="30"
                            name="30"
                            value="30"
                            onClick={e => {
                              handleOnDropdownItem(e);
                            }}
                          />
                        </DropdownList>
                        <span className="sub-main-text">{i18n.t('BTY_W_T_DAY')}</span>
                      </div>
                      <div className="data-row">
                        <label htmlFor="checkbox">
                          <i className="check" />
                          <span className="sub-main-text">{i18n.t('BTY_W_T_LAST_PERIOD')}</span>
                        </label>
                        <span className="space" />
                        <DropdownList
                          componentType="border"
                          id="expArtiKeepMmNum"
                          label={expArtiKeepMmNum}
                          value={expArtiKeepMmNum}
                        >
                          {[...Array(3)].map((n, index) => {
                            return (
                              <dropdownItem
                                key={n}
                                name={index + 1}
                                value={index + 1}
                                onClick={e => {
                                  formik.setFieldValue('expArtiKeepMmNum', e.value);
                                  setExpArtiKeepMmNum(e.value);
                                }}
                              />
                            );
                          })}
                        </DropdownList>
                        <span className="sub-main-text">{i18n.t('BTY_W_T_DAY_MONTH')}</span>
                      </div>
                    </>
                  )}
                </div>
              </TblList>

              <TblList>
                <TblCell isHeader>{i18n.t('BTY_W_T_DETAIL_SETTING')}</TblCell>
                <TblCell>
                  <Checkbox
                    id="rcmdUseYn"
                    label={i18n.t('BTY_W_T_USE_RECOMMEND')}
                    tooltipInfo={{
                      title: `${i18n.t('BTY_W_T_USE_RECOMMEND')}`,
                    }}
                    checked={formik.getFieldProps('rcmdUseYn').value === 'Y'}
                    onClick={() => {
                      onSelectedChanged('rcmdUseYn');
                    }}
                  />
                  <Checkbox
                    id="cmntUseYn"
                    label={i18n.t('BTY_W_T_USE_LIKE')}
                    tooltipInfo={{
                      title: `${i18n.t('BTY_W_T_USE_LIKE')}`,
                    }}
                    checked={formik.getFieldProps('cmntUseYn').value === 'Y'}
                    onClick={() => {
                      onSelectedChanged('cmntUseYn');
                    }}
                  />
                  <Checkbox
                    id="rplUseYn"
                    label={i18n.t('BTY_W_T_USE_REPLY')}
                    checked={formik.getFieldProps('rplUseYn').value === 'Y'}
                    tooltipInfo={{
                      title: `${i18n.t('BTY_W_T_USE_REPLY')}`,
                    }}
                    onClick={() => {
                      onSelectedChanged('rplUseYn');
                    }}
                  />
                </TblCell>
              </TblList>
              <div>
                <Checkbox
                  isLeftPosition
                  id="portlet"
                  label={i18n.t('BTY_W_T_USE_POTLIT')}
                  checked={formik.getFieldProps('portlet').value === 'Y'}
                  onClick={() => {
                    onSelectedChanged('portlet');
                  }}
                />
              </div>
            </div>,
          ]}
          bottomComponent={[<PopConfirmButton confirmAction={formik.submitForm} cancelAction={handleOnClosePopup} />]}
        />
      )}
    </>
  );
};
PopupBoard.propTypes = {};
PopupBoard.defaultProps = {};
export default PopupBoard;
